import { render } from "./AboutView.vue?vue&type=template&id=7d3f75fb"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ASUS\\Documents\\PROFESSIONNEL\\DVPT-WEB\\pierre-hydraulic\\phs-website-Vuejs-V1.1.1\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__